import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/country'
export const namespace = 'country'
export const clientRoute = '/address/country'
export const dependencies = []
export const params = {
  include: ''
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'name'
const subtitleColumn = 'alpha3Code'
const infoColumns = ['alpha2Code']
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
